import { Layers, Sparkles, ShieldCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
const technicalFeatures = [{
  title: "Publishers Own Their Data",
  description: "Publishers retain ownership and control of their first-party data. ESMG provides infrastructure for permitted audience intelligence and advertising activation.",
  icon: Layers
}, {
  title: "Anonymized Insights",
  description: "Behavioral signals are used to develop relevant audience segments without providing advertisers with identifiable athlete profiles.",
  icon: Sparkles
}, {
  title: "Privacy-First Compliance",
  description: "ESMG applies consent and privacy eligibility controls to support responsible audience activation across supported advertising platforms.",
  icon: ShieldCheck
}];
export default function TheScienceOfShine() {
  return <section data-section-id="240462" id="privacy-first-infrastructure" className="bg-[#000000] text-white py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center text-center mb-16 md:mb-24">
          <span className="font-mono text-xs tracking-widest uppercase mb-4 border border-[#66cc33]/30 rounded-lg px-4 py-1.5 inline-block bg-[#66cc33]/5 text-primary">
            Privacy & Trust
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-sans font-bold tracking-tighter mb-6 text-white">First-Party Athlete Signals. Privacy-Conscious Advertising.</h2>
          <p className="text-[#999999] font-sans text-sm md:text-base max-w-2xl leading-relaxed">ESMG uses first-party behavioral signals from its endurance publisher network and server-side infrastructure to support audience creation and advertising activation, subject to applicable consent and privacy controls.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {technicalFeatures.map((feature, i) => <Card key={i} data-index={i} className="bg-[#1a1a1a] border-[#333333] shadow-lg hover:border-[#66cc33]/50 transition-all duration-500 rounded-lg group">
              <CardHeader className="pb-4">
                <div className="w-14 h-14 rounded-lg bg-[#66cc33]/10 flex items-center justify-center mb-6 border border-[#66cc33]/20 group-hover:bg-[#66cc33]/20 transition-colors duration-500">
                  <feature.icon className="w-7 h-7 text-[#66cc33]" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-sans text-2xl font-bold tracking-tight text-white transition-colors duration-300 group-hover:text-primary">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="font-sans text-sm leading-relaxed text-[#999999]">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}